<template>
  <div id="registraion-list" class="page-container">
    <!-- Premium Page Header -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-gradient">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="8">
              <div class="d-flex align-center">
                <div class="header-icon-box">
                  <v-icon large color="white">mdi-file-check</v-icon>
                </div>
                <div class="ml-6">
                  <h1 class="header-title white--text mb-1">{{ PageTitle }}</h1>
                  <p class="header-subtitle white--text mb-0">
                    {{ PageDescription }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <div class="d-flex justify-end flex-wrap gap-2">
                <v-btn
                  @click.prevent="refreshPageData"
                  color="rgba(255,255,255,0.2)"
                  elevation="0"
                  rounded
                  large
                  class="action-btn"
                >
                  <v-icon left>mdi-refresh</v-icon>
                  Refresh
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <!-- Loading State -->
    <div v-if="LoadingFlag" class="text-center py-12">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <p class="mt-4 text-h6 primary--text">Loading registrations...</p>
    </div>

    <!-- Records Found Alert -->
    <v-card
      elevation="8"
      class="records-info-card mb-6"
      v-if="!LoadingFlag && tableData1.length > 0"
    >
      <v-card-text class="pa-4">
        <div class="d-flex align-center">
          <v-icon large color="primary" class="mr-4"
            >mdi-file-document-multiple</v-icon
          >
          <div>
            <p class="text-subtitle2 font-weight-bold mb-0">
              Total Registrations
            </p>
            <p class="text-h4 font-weight-bold mb-0 primary--text">
              {{ tableData1.length }}
            </p>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- No Records Alert -->
    <v-card
      elevation="8"
      class="mb-4"
      v-if="!LoadingFlag && tableData1.length === 0"
    >
      <v-card-text class="pa-6">
        <v-alert type="info" dense outlined icon="mdi-information" prominent>
          <v-alert-title>No Registrations Found</v-alert-title>
          No program registrations available at the moment.
        </v-alert>
      </v-card-text>
    </v-card>

    <!-- Search Bar -->
    <v-card elevation="8" class="search-card mb-6" v-if="tableData1.length > 0">
      <v-card-text class="pa-4">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search registrations..."
          single-line
          outlined
          rounded
          dense
          class="search-input"
        ></v-text-field>
      </v-card-text>
    </v-card>

    <!-- Data Table Section -->
    <v-card elevation="12" class="table-card" v-if="tableData1.length > 0">
      <div class="table-wrapper">
        <v-data-table
          class="professional-table"
          loading-text="Loading... Please wait"
          v-model="selected"
          :search="search"
          :item-key="tableOptions1.ItemKey"
          :single-select="tableOptions1.SingleSelectFlag"
          :headers="tableColumns1"
          :items="tableData1"
          :items-per-page="tableOptions1.ItemsPerPage"
          :footer-props="tableOptions1.FooterProps"
        >
          <!-- Status Column -->
          <template v-slot:[`item.ActiveStatusTxt`]="{ item }">
            <v-chip :color="item.ActiveStatusColor" dark class="status-chip">
              <v-icon small left>mdi-check-circle</v-icon>
              {{ item.ActiveStatusTxt }}
            </v-chip>
          </template>

          <!-- Profile Picture Column -->
          <template v-slot:[`item.ProfilePic`]="{ item }">
            <div class="profile-pic-container">
              <img
                class="profile-pic"
                :src="item.ProfilePic"
                :alt="item.ProfilePic"
              />
            </div>
          </template>

          <!-- Actions Column -->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="action-buttons-group">
              <v-btn
                v-if="item.ReceiptPath != ''"
                :href="item.ReceiptPath"
                target="_blank"
                color="#10b981"
                small
                elevation="4"
                class="action-btn-receipt white--text font-weight-bold"
              >
                <v-icon small left>mdi-file-pdf</v-icon>
                Receipt
              </v-btn>

              <v-btn
                v-if="item.ApplicationPath != ''"
                :href="item.ApplicationPath"
                target="_blank"
                color="#667eea"
                small
                elevation="4"
                class="action-btn-app white--text font-weight-bold"
              >
                <v-icon small left>mdi-file-document</v-icon>
                Application
              </v-btn>

              <v-tooltip bottom v-if="EditFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="warning"
                    @click="editData(item, $event)"
                    v-bind="attrs"
                    v-on="on"
                    class="icon-btn"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>

              <v-tooltip bottom v-if="PreviewFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="previewData(item, $event)"
                    v-bind="attrs"
                    v-on="on"
                    class="icon-btn"
                  >
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Preview</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SearchFlag: false,
      EditFlag: false,
      PreviewFlag: false,

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      ZoneCode: "",
      LomCode: "",
      MemberId: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;
        this.EditFlag = tr.EditFlag;
        this.PreviewFlag = tr.PreviewFlag;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomCode = this.$session.get("LomId");
        this.LomCode = LomCode == (null || undefined) ? 0 : LomCode;
        console.log("LomCode=" + LomCode);

        var ZoneCode = this.$session.get("ZoneId");
        this.ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        this.ZoneCode = ZoneCode;

        var MemberId = this.$session.get("MemberId");
        this.MemberId = MemberId;
        console.log({ MemberId });

        this.searchForm();
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jci_events",
        Action: "list_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    searchForm() {
      console.log("searchForm is called");

      var ZoneCode = this.ZoneCode;
      var LomCode = this.LomCode;
      var MemberId = this.MemberId;

      console.log(
        " ZoneCode=" +
          ZoneCode +
          ", LomCode=" +
          LomCode +
          ", MemberId=" +
          MemberId
      );

      if (ZoneCode != "" && LomCode != "" && MemberId != "") {
        this.LoadingFlag = true;
        this.tableData1 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/registration/paid-lists";
        var upload = {
          UserInterface: 1,
          Zone: this.ZoneCode,
          Lom: this.LomCode,
          MemberId: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            var options = records.TableOptions;
            thisIns.tableOptions1 = options;

            if (flag == 1) {
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableData1 = records.TableData;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "";
        if (ZoneCode == "" || LomCode == "" || MemberId == "") {
          message += "Your session is expired. Kindly login again. ";
        }
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 1;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
    this.CurrentYearId = CurrentYearId;
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Color Palette
$primary-color: #667eea;
$secondary-color: #764ba2;
$gradient-main: linear-gradient(
  135deg,
  $primary-color 0%,
  $secondary-color 100%
);
$success-color: #10b981;
$danger-color: #f44336;
$warning-color: #f59e0b;
$card-shadow: 0 16px 48px rgba(102, 126, 234, 0.15);

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#registraion-list {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;
  animation: fadeIn 0.6s ease-in-out;

  // ============================================
  // HEADER CARD
  // ============================================
  .header-card {
    background: $gradient-main !important;
    border-radius: 16px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.4);

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 70%
      );
      animation: rotate 20s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 1;
    }
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    animation: float 3s ease-in-out infinite;
  }

  .header-title {
    font-size: 32px;
    font-weight: 700;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    animation: fadeInUp 0.8s ease-out;
    letter-spacing: 0.5px;
  }

  .header-subtitle {
    font-size: 16px;
    opacity: 0.95;
    animation: fadeInUp 1s ease-out;
    letter-spacing: 0.3px;
  }

  .action-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    color: white !important;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
      background: rgba(255, 255, 255, 0.25) !important;
    }
  }

  // ============================================
  // RECORDS INFO CARD
  // ============================================
  .records-info-card {
    border-radius: 14px !important;
    border: none;
    box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
    animation: slideInLeft 0.8s ease-out;

    .v-card__text {
      display: flex;
      align-items: center;
    }
  }

  // ============================================
  // SEARCH CARD
  // ============================================
  .search-card {
    border-radius: 14px !important;
    border: none;
    box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
    animation: fadeInUp 0.8s ease-out 0.1s backwards;

    .search-input {
      ::v-deep {
        .v-input__prepend-inner {
          margin-right: 12px;
        }

        .v-field__input {
          font-size: 16px;
        }
      }
    }
  }

  // ============================================
  // TABLE CARD
  // ============================================
  .table-card {
    border-radius: 14px !important;
    border: none;
    overflow: hidden;
    animation: fadeInUp 0.8s ease-out 0.2s backwards;

    .table-wrapper {
      padding: 0;
      overflow-x: auto;
    }

    .professional-table {
      ::v-deep {
        // Header Styling
        thead {
          background: $gradient-main;

          th {
            color: white !important;
            font-weight: 700 !important;
            font-size: 14px !important;
            letter-spacing: 0.3px;
            padding: 16px 12px !important;
            border-bottom: 3px solid rgba(255, 255, 255, 0.2) !important;
          }
        }

        // Body Row Styling
        tbody {
          tr {
            border-bottom: 1px solid rgba(102, 126, 234, 0.1);
            transition: all 0.3s ease;

            &:hover {
              background-color: rgba(102, 126, 234, 0.08) !important;
              box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
            }

            td {
              padding: 14px 12px !important;
              color: #555;
              font-size: 14px;
            }
          }
        }

        // Footer Styling
        tfoot {
          background: rgba(102, 126, 234, 0.05);

          tr {
            border-top: 2px solid rgba(102, 126, 234, 0.2) !important;
          }
        }
      }
    }
  }

  // ============================================
  // PROFILE PICTURE
  // ============================================
  .profile-pic-container {
    display: flex;
    align-items: center;
    justify-content: center;

    .profile-pic {
      width: 80px;
      height: 80px;
      border-radius: 12px;
      object-fit: cover;
      border: 3px solid $primary-color;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  // ============================================
  // STATUS CHIP
  // ============================================
  .status-chip {
    font-weight: 600 !important;
    letter-spacing: 0.3px;
    padding: 8px 12px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

    .v-icon {
      margin-right: 4px !important;
    }
  }

  // ============================================
  // ACTION BUTTONS
  // ============================================
  .action-buttons-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .action-btn-receipt,
  .action-btn-app {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    font-weight: 600;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    border-radius: 6px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25) !important;
    }

    .v-icon {
      font-size: 16px !important;
    }
  }

  .action-btn-receipt {
    background: linear-gradient(
      135deg,
      $success-color 0%,
      #059669 100%
    ) !important;
  }

  .action-btn-app {
    background: linear-gradient(
      135deg,
      $primary-color 0%,
      $secondary-color 100%
    ) !important;
  }

  .icon-btn {
    transition: all 0.3s ease !important;

    &:hover {
      transform: scale(1.1);
    }
  }

  // ============================================
  // UTILITY CLASSES
  // ============================================
  .page-container {
    width: 100%;
  }

  .gap-2 {
    gap: 8px;
  }

  .text-right {
    text-align: right;
  }

  .justify-end {
    justify-content: flex-end;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .ml-6 {
    margin-left: 24px;
  }

  .mb-6 {
    margin-bottom: 24px;
  }

  .mb-4 {
    margin-bottom: 16px;
  }

  .mr-4 {
    margin-right: 16px;
  }

  .mr-3 {
    margin-right: 12px;
  }

  .mr-2 {
    margin-right: 8px;
  }

  .mb-1 {
    margin-bottom: 4px;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .py-12 {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .pa-8 {
    padding: 32px;
  }

  .pa-6 {
    padding: 24px;
  }

  .pa-4 {
    padding: 16px;
  }

  .mt-4 {
    margin-top: 16px;
  }

  .d-flex {
    display: flex;
  }

  .align-center {
    align-items: center;
  }

  .white--text {
    color: white;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .primary--text {
    color: $primary-color;
  }

  .font-weight-bold {
    font-weight: 700;
  }

  .text-h4 {
    font-size: 34px;
  }

  .text-h6 {
    font-size: 20px;
  }

  .text-subtitle2 {
    font-size: 14px;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 1200px) {
    .header-title {
      font-size: 26px;
    }

    .header-subtitle {
      font-size: 14px;
    }
  }

  @media (max-width: 960px) {
    padding: 20px 10px;

    .header-card {
      margin-bottom: 16px;
    }

    .header-title {
      font-size: 22px;
    }

    .header-subtitle {
      font-size: 12px;
    }

    .action-btn {
      font-size: 12px !important;
      padding: 8px 12px !important;

      .v-icon {
        font-size: 16px !important;
      }
    }

    .profile-pic {
      width: 60px;
      height: 60px !important;
    }

    .action-btn-receipt,
    .action-btn-app {
      font-size: 11px !important;
      padding: 6px 8px !important;

      .v-icon {
        font-size: 14px !important;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 15px 8px;

    .header-card {
      margin-bottom: 12px;
    }

    .header-title {
      font-size: 18px;
    }

    .header-subtitle {
      font-size: 11px;
    }

    .action-btn {
      font-size: 10px !important;
      padding: 6px 10px !important;

      .v-icon {
        font-size: 14px !important;
      }
    }

    .profile-pic {
      width: 50px;
      height: 50px !important;
    }

    .action-btn-receipt,
    .action-btn-app {
      font-size: 10px !important;
      padding: 6px 8px !important;

      .v-icon {
        font-size: 12px !important;
      }
    }

    .action-buttons-group {
      gap: 4px;
    }

    ::v-deep .v-data-table {
      font-size: 12px !important;

      thead th {
        font-size: 12px !important;
        padding: 12px 8px !important;
      }

      tbody td {
        padding: 10px 8px !important;
      }
    }
  }
}
</style>